// Persistierter Method-Wert auf einem Board (board.method_template-Spalte).
// Validiert nur, dass es nicht leer ist; die ID muss im METHOD_CATALOG existieren —
// das wird beim Insert serverseitig nicht hart geprueft (S5 fuegt Schema-Check hinzu).
import { z } from "zod";

export const MethodTemplateRefSchema = z.string().min(1);
export type MethodTemplateRef = z.infer<typeof MethodTemplateRefSchema>;
